import { render, staticRenderFns } from "./PageFamily.vue?vue&type=template&id=bb260c14"
import script from "./PageFamily.vue?vue&type=script&lang=js"
export * from "./PageFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports